<kendo-dialog *ngIf="notesDialogOpened" (close)="cancelNote()" [minWidth]="400" [width]="900">
  <kendo-dialog-titlebar>
    <h3 *ngIf="!editMode" title="{{note.title}}" class="ellipsis-text">{{note.title}}</h3>
    <input kendoTextBox *ngIf="editMode" [(ngModel)]="note.title" style="max-width: 97%" class="w-100"
      maxlength="255" />
  </kendo-dialog-titlebar>
  <h6 class="text-muted">
    <span>{{note.createdOn | date:'medium'}}</span>
    <strong class="float-right">{{note?.author?.name}}</strong>
  </h6>
  <hr>
  <p style="max-height: 500px;" *ngIf="!editMode" [innerHTML]="note.body | replaceLineBreaks | safe:'html'"></p>
  <textarea *ngIf="editMode" kendoTextArea class="w-100" [(ngModel)]="note.body" maxlength="{{maxNoteLength}}" rows="10"
    style="overflow-y: auto;max-height: 500px;"></textarea>
  <span *ngIf="editMode">{{note.body ? note.body.length : 0}}/{{maxNoteLength}}</span>
  <span *ngIf="!editMode && !note.taskId && note.author.id === this.authenticationService.currentUser.id"
    class="float-right">
    <i class="fas fa-edit fa-lg" (click)="editMode=true" title="{{ 'EDIT-NOTE' | translate }}"></i>
    &nbsp;&nbsp;
    <i class="fas fa-trash-alt fa-lg" (click)="deleteConfirmationOpened=true"
      title="{{ 'DELETE-NOTE' | translate }}"></i>
  </span>
  <kendo-dialog-actions *ngIf="!editMode">
    <button kendoButton (click)="cancelNote()">{{ 'CLOSE' | translate }}</button>
  </kendo-dialog-actions>
  <kendo-dialog-actions *ngIf="editMode">
    <button kendoButton (click)="cancelNote()">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick kendoButton (click)="save()" [primary]="true" [disabled]="!note.title || !note.body">{{
      'SAVE' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>
<!--Note deletion confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteConfirmationOpened"
  (close)="deleteConfirmationOpened=false" [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-DELETION' | translate }}</p>
  <span class="k-font-weight-bold">{{note.title}}</span>
  <kendo-dialog-actions>
    <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>